import React from 'react';
import ProductOpinionSummary
    from '../product-opinion-section/components/product-opinion-summary/product-opinion-summary';
import ProductOpinionList
    from '../product-opinion-section/components/product-opinion-list/product-opinion-list';
import { ProductInterface } from 'modules/product/interfaces/product.interface';
import './product-opinion-section.scss';

const ProductOpinionSection: React.FC<{ product: Pick<ProductInterface, 'name' | 'opinions'>; }> = ({ product }) => (
    <div className="opinion-section">
        <ProductOpinionSummary
            title={product.name}
            url={product.opinions.url}
            count={product.opinions.count}
            average={product.opinions.average}
            ratings={product.opinions.ratings}
        />
        <ProductOpinionList
            url={product.opinions.url}
            count={product.opinions.count}
            items={product.opinions.items}
        />
    </div>
);

export default ProductOpinionSection;
